module.exports = __webpack_public_path__ + "img/home_page.349c91ee.png";